/* @ngInject */
const myOwnerPie = (
  wagonFields,
  $q,
) => {
  return {
    restrict: 'E',
    scope: {

    },
    template: require('./myOwnerPie.html'),
    /* @ngInject */
    controller: ($scope, $$owner) => {
      const init = async () => {
        $scope.ownerPieLabels = []
        $scope.ownerPieData = []
        $scope.owner2PieLabels = []
        $scope.owner2PieData = []
        $scope.ownerPieColors = []
        $scope.owner2PieColors = []

        const owners = (await $$owner.request.getAll()).owners

        const wagonsCountPromises = []
        const parkedWagonsCountPromises = []

        owners.forEach(async (owner) => {
          wagonsCountPromises.push($$owner.request.countWagons(owner.id))
          parkedWagonsCountPromises.push($$owner.request.countParkedWagons(owner.id))

          $scope.ownerPieLabels.push(owner.society)
          $scope.owner2PieLabels.push(owner.society)
        })

        $scope.ownerPieData = await Promise.all(wagonsCountPromises)
        $scope.owner2PieData = await Promise.all(parkedWagonsCountPromises)

        $scope.ownerPieData = $scope.ownerPieData.sort((a, b) => +a < +b)
        $scope.owner2PieData = $scope.owner2PieData.sort((a, b) => +a < +b)
      }

      init()
    },
    link: {
      pre: (scope, element, attrs) => { },
      post: (scope, element, attrs, ctrl) => { },
    },
  }
}
export default myOwnerPie



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/stat/myOwnerPie.js